// extracted by mini-css-extract-plugin
export default {"content":"delete-art-folder-logo-popup__content___jsIXu","button":"delete-art-folder-logo-popup__button___xmX4y"};